module.exports = __webpack_public_path__ + "static/img/19grxx.34db251.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu_icon/19grxx.png
// module id = /08a
// module chunks = 58